import React from "react";
import { TID } from "@/lib/testIds";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-zinc-800 bg-zinc-950/60">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div
          data-testid={TID.footerDisclaimer}
          className="text-xs sm:text-sm text-zinc-400 leading-relaxed max-w-4xl"
        >
          <div className="text-white font-semibold mb-1.5 tracking-tight">免責聲明 · Disclaimer</div>
          本平台提供之內容僅作為研究與資訊整理參考，不構成任何投資建議。
          所有財務數據、新聞與 AI 分析結果均為情境展示用，實際情形以官方公告為準。
          投資有風險，請自行判斷並諮詢專業人士。
        </div>
        <div className="mt-6 flex flex-wrap items-center justify-between gap-2 text-[10px] uppercase tracking-widest text-zinc-600 font-mono">
          <span>© 2025 AI Stock Research Dashboard</span>
          <span>Powered by Claude Sonnet 4.5 · Emergent</span>
        </div>
      </div>
    </footer>
  );
}
